import { getDoc, Role, roleRef } from '../firebase'

export const hasRole = async (uid: string, role: Role['id']) => {
  const roleSnapshot = await getDoc(roleRef(uid, role))
  return roleSnapshot.exists()
}
